
<div class="parent fx-row">
  <div class="left">
    <about-company></about-company>
  </div>
  <div class="right">
    <section>
      <form [formGroup]="resetPassword">
        <mat-card>
          <h2>
            Forgot Password?
          </h2>
          <mat-card-content>
            <mat-form-field appearance="outline" subscriptSizing="dynamic" hideRequiredMarker>
              <mat-label>Enter verfication code</mat-label>
              <input class="resetPassword-email-input" matInput formControlName="verficationCode" placeholder="Enter your verfication code" autocomplete="off" minlength="6"  maxlength="6">
              @if (resetPassword.get('verficationCode').touched && resetPassword.get('verficationCode').hasError('required')) {
                <mat-error>Verfication Code is required</mat-error>
              }
              @if (resetPassword.get('verficationCode').touched && resetPassword.get('verficationCode').hasError('minlength')) {
                <mat-error>Six character verfication code required</mat-error>
              }
            </mat-form-field>
            <div class="field-spacer"></div>
            <mat-form-field appearance="outline" subscriptSizing="dynamic" hideRequiredMarker>
              <mat-label>Enter new password</mat-label>
              <input [type]="hide ? 'password' : 'text'" class="resetPassword-email-input" matInput formControlName="newPassword" placeholder="Enter your new password" autocomplete="off" minlength="4" maxlength="15">
              @if (resetPassword.get('newPassword').touched && resetPassword.get('newPassword').hasError('required')) {
                <mat-error>new password field required</mat-error>
              }
              @if (resetPassword.get('newPassword').touched && resetPassword.get('newPassword').hasError('minlength')) {
                <mat-error>Minimum 4 character are required</mat-error>
              }
              <mat-icon class="__show_psw" matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </mat-form-field>
            <div class="field-spacer"></div>
            <mat-form-field appearance="outline" subscriptSizing="dynamic" hideRequiredMarker>
              <mat-label>Enter confirm password</mat-label>
              <input [type]="hideConfirm ? 'password' : 'text'" class="resetPassword-email-input" matInput formControlName="oldPassword" placeholder="Enter your confirm password" autocomplete="off" minlength="4" maxlength="15">
              @if (resetPassword.get('oldPassword').touched && resetPassword.get('oldPassword').hasError('required')) {
                <mat-error>confirm password field required</mat-error>
              }
              @if (resetPassword.get('oldPassword').touched && resetPassword.get('oldPassword').hasError('minlength')) {
                <mat-error>Minimum 4 character are required</mat-error>
              }
              @if (resetPassword.get('oldPassword').touched && resetPassword.get('oldPassword').hasError('mustMatch')) {
                <mat-error>password doesn't matched</mat-error>
              }
              <mat-icon class="__show_psw" matSuffix (click)="hideConfirm = !hideConfirm">{{hideConfirm ? 'visibility_off' : 'visibility'}}</mat-icon>
            </mat-form-field>
          </mat-card-content>
          <mat-card-actions>
            <button mat-button color="cancel" (click)="onCancle()">CANCEL</button>
            <button mat-button color="primary" (click)="onSubmit()">SUBMIT</button>
          </mat-card-actions>
        </mat-card>
      </form>
    </section>
  </div>
</div>